import { getRequest } from 'utils/http';
import { mapDataToClient } from './mapData';
import { UserChannelsCollection } from './types';

export async function getUserChannelsAPI(subscriptionId: string, externalProductId: string, ts: string, code: string) {
    const url = `/user/tv-channels?subscriptionId=${subscriptionId}&externalProductId=${externalProductId}&ts=${ts}&code=${encodeURIComponent(code)}`;

    return getRequest<UserChannelsCollection>(url, { mapData: mapDataToClient });
}
